// Resolves a photo reference to a displayable URL.
// External (seed/Unsplash) URLs and data/blob URLs are returned as-is;
// backend-served object-storage photos (relative /api/files/...) get the backend origin prepended.
export function photoUrl(url) {
  if (!url) return url;
  if (typeof url === "object") url = url.url || url.thumbnail || "";
  if (typeof url !== "string") return null;
  if (url.startsWith("http") || url.startsWith("data:") || url.startsWith("blob:")) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url}`;
}
